function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { DeviceType } from '@sky-uk-ott/client-lib-js-device';
import { NielsenTrackingType } from '../../addons/addon-playout-data';
import { AsidVersion } from '../../addons/watermarking/friend-watermarking-addon/friends-watermarking-config';
import { PlaybackType, DrmType as SdkDrmType, StreamQuality, StreamingProtocol } from '../../core/player/playout-data';
import { VideoColourSpace, VideoFormat } from '../../core/player/video-format';
import { sdkLogger } from '../../logger';
import { checkIsManifestLinearType, checkIsManifestVodType } from '../../utils/playback-type';
import { getLinearStreamInfo } from '../../utils/stream-vendor';
import { Url } from '../url';
import { CoreVideoInternal } from '../../core-video-internal';
import { OvpUrlExtendedWindowManager } from './ovp-url-extended-window-manager/ovp-url-extended-window-manager';
import { OvpUrlTemplateManager } from './ovp-url-template-manager/ovp-url-template-manager';
import { OvpColourSpace, OvpNielsenTrackingType, OvpVideoCodec, OvpVideoFormat, StreamTransport, DrmType, OvpJourneyContext } from '@sky-uk-ott/core-video-sdk-js-ovp-service';
import { OvpErrorAdapter, OvpErrorSource } from './ovp-error-adapter';
import { TestingOverrides } from '../../core/services/testing-overrides';
var _obj;
var STREAM_TRANSPORT_TO_STREAMING_PROTOCOL_MAP = (_obj = {}, _define_property(_obj, StreamTransport.DASH, StreamingProtocol.DASH), _define_property(_obj, StreamTransport.HSS, StreamingProtocol.MSS), _define_property(_obj, StreamTransport.HLS, StreamingProtocol.HLS), _define_property(_obj, StreamTransport.PDL, StreamingProtocol.PDL), _define_property(_obj, StreamTransport.PSF, StreamingProtocol.PSF), _obj);
var _obj1;
var VIDEO_FORMAT_TO_STREAM_QUALITY_MAP = (_obj1 = {}, _define_property(_obj1, OvpVideoFormat.HD, StreamQuality.HD), _define_property(_obj1, OvpVideoFormat.SD, StreamQuality.SD), _define_property(_obj1, OvpVideoFormat.UHD, StreamQuality.UHD), _define_property(_obj1, OvpVideoFormat.UNKNOWN, null), _obj1);
var _obj2;
var OVP_DRM_TYPE_TO_SDK_DRM_TYPE = (_obj2 = {}, _define_property(_obj2, DrmType.PlayReady, SdkDrmType.PlayReady), _define_property(_obj2, DrmType.Marlin, SdkDrmType.Marlin), _define_property(_obj2, DrmType.Widevine, SdkDrmType.Widevine), _define_property(_obj2, DrmType.Fairplay, SdkDrmType.Fairplay), _define_property(_obj2, DrmType.None, null), _obj2);
var _obj3;
var SDK_VIDEO_FORMAT_TO_OVP = (_obj3 = {}, _define_property(_obj3, VideoFormat.SD, OvpVideoFormat.SD), _define_property(_obj3, VideoFormat.HD, OvpVideoFormat.HD), _define_property(_obj3, VideoFormat.UHD, OvpVideoFormat.UHD), _obj3);
// Using map specifically so keys can be iterated through in order of colour space preference
// OVP expects an ordered list
var SDK_COLOUR_SPACE_TO_OVP = new Map([
    [
        VideoColourSpace.DV,
        OvpColourSpace.DolbyVision
    ],
    [
        VideoColourSpace.HDR10,
        OvpColourSpace.HDR10
    ],
    [
        VideoColourSpace.HDRHLG,
        OvpColourSpace.HLG
    ],
    [
        VideoColourSpace.SDR,
        OvpColourSpace.SDR
    ]
]);
var NORMAL_VOD_SIX_SECONDS = 'mpeg_cenc';
var NORMAL_VOD_TWO_SECONDS = 'mpeg_cenc_2sec';
var SHORTFORM_SIX_SECONDS = 'mpeg_6sec';
var SHORTFORM_TWO_SECONDS = 'mpeg_2sec';
var STANDARD_MPD = 'master_cmaf.mpd';
var PS4_MPD = 'master_cmaf_fxbw.mpd';
export var OvpDataAdapters = /*#__PURE__*/ function() {
    "use strict";
    function OvpDataAdapters(coreVideoInternal, hdcpManager) {
        var _this = this;
        _class_call_check(this, OvpDataAdapters);
        var _this1 = this;
        _define_property(this, "coreVideoInternal", void 0);
        _define_property(this, "hdcpManager", void 0);
        _define_property(this, "getHdcpEnabled", void 0);
        _define_property(this, "getMaxVideoFormat", void 0);
        this.coreVideoInternal = coreVideoInternal;
        this.hdcpManager = hdcpManager;
        this.getHdcpEnabled = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(vpiSessionRequestOptions) {
                var _this_hdcpManager, _this_hdcpManager_isCompliant;
                return _ts_generator(this, function(_state) {
                    if (vpiSessionRequestOptions.hdcpEnabled === undefined) {
                        ;
                        ;
                        // If there's a resolution cap due to HDCP
                        // We are going to cap the resolution to a low enough value that it's safe to disable HDCP
                        return [
                            2,
                            (_this_hdcpManager_isCompliant = (_this_hdcpManager = _this1.hdcpManager) === null || _this_hdcpManager === void 0 ? void 0 : _this_hdcpManager.isCompliant) !== null && _this_hdcpManager_isCompliant !== void 0 ? _this_hdcpManager_isCompliant : false
                        ];
                    }
                    return [
                        2,
                        vpiSessionRequestOptions.hdcpEnabled
                    ];
                });
            });
            return function(vpiSessionRequestOptions) {
                return _ref.apply(this, arguments);
            };
        }();
        this.getMaxVideoFormat = function(sessionItem) {
            var _sessionItem_videoFormatConfig_support, _sessionItem_videoFormatConfig, _sessionItem_display;
            var sdkMaxVideoFormat = _this.adaptSdkMaxVideoFormat((_sessionItem_videoFormatConfig = sessionItem.videoFormatConfig) === null || _sessionItem_videoFormatConfig === void 0 ? void 0 : (_sessionItem_videoFormatConfig_support = _sessionItem_videoFormatConfig.support) === null || _sessionItem_videoFormatConfig_support === void 0 ? void 0 : _sessionItem_videoFormatConfig_support.maxVideoFormat, (_sessionItem_display = sessionItem.display) === null || _sessionItem_display === void 0 ? void 0 : _sessionItem_display.playerViewAlwaysPresentedFullScreen);
            var maxVideoFormat = sdkMaxVideoFormat !== undefined && SDK_VIDEO_FORMAT_TO_OVP[sdkMaxVideoFormat] ? SDK_VIDEO_FORMAT_TO_OVP[sdkMaxVideoFormat] : undefined;
            return maxVideoFormat;
        };
    }
    _create_class(OvpDataAdapters, [
        {
            key: "adaptSupportedColourSpaces",
            value: function adaptSupportedColourSpaces(sdkColourSpaces, playerViewAlwaysPresentedFullScreen) {
                if (!sdkColourSpaces || sdkColourSpaces.length === 0) {
                    return undefined;
                }
                // specific behaviour for Playstation and Xbox for now
                if (this.coreVideoInternal.display()) {
                    var supportsResizeWithHdr = this.coreVideoInternal.display().supportsResizeWithHdr();
                    var explicitActivateColourSpace = !!this.coreVideoInternal.display().activateColourSpace;
                    if ((explicitActivateColourSpace || !supportsResizeWithHdr) && !playerViewAlwaysPresentedFullScreen) {
                        return [
                            OvpColourSpace.SDR
                        ];
                    }
                }
                var supportedColourSpaces = new Array();
                var sdkColourSpacesSet = new Set(sdkColourSpaces);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = SDK_COLOUR_SPACE_TO_OVP[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = _sliced_to_array(_step.value, 2), key = _step_value[0], value = _step_value[1];
                        if (sdkColourSpacesSet.has(key)) {
                            supportedColourSpaces.push(value);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return supportedColourSpaces;
            }
        },
        {
            key: "adaptSdkMaxVideoFormat",
            value: function adaptSdkMaxVideoFormat(sdkMaxVideoFormat, playerViewAlwaysPresentedFullScreen) {
                if (sdkMaxVideoFormat === undefined) {
                    return undefined;
                }
                if (this.coreVideoInternal.display() && sdkMaxVideoFormat === VideoFormat.UHD) {
                    var supportsResizeWithUhd = this.coreVideoInternal.display().supportsResizeWithUhd();
                    if (!supportsResizeWithUhd && !playerViewAlwaysPresentedFullScreen) {
                        return VideoFormat.HD;
                    }
                }
                return sdkMaxVideoFormat;
            }
        },
        {
            key: "getJourneyContextFromVpiSessionRequestOptions",
            value: function getJourneyContextFromVpiSessionRequestOptions(sessionItem, vpiSessionRequestOptions) {
                if (vpiSessionRequestOptions.isPrefetch) {
                    return OvpJourneyContext.PreFetch;
                }
                if (vpiSessionRequestOptions.isRetrying) {
                    return OvpJourneyContext.VpfRetry;
                }
                return sessionItem.journeyContext;
            }
        },
        {
            key: "getVariantCapableFromPropositionExtensionsAndSessionItemOverrides",
            value: function getVariantCapableFromPropositionExtensionsAndSessionItemOverrides(sessionItem) {
                if (sessionItem.enableVariantCapableOverride === undefined) {
                    var _this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig_endpoints_sessionItem_type, _this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig_endpoints, _this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig;
                    return Boolean((_this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig = this.coreVideoInternal.getPropositionExtensions().propositionOvpConfig) === null || _this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig === void 0 ? void 0 : (_this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig_endpoints = _this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig.endpoints) === null || _this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig_endpoints === void 0 ? void 0 : (_this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig_endpoints_sessionItem_type = _this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig_endpoints[sessionItem.type]) === null || _this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig_endpoints_sessionItem_type === void 0 ? void 0 : _this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig_endpoints_sessionItem_type.variantCapable);
                }
                // Testing override
                return Boolean(sessionItem.enableVariantCapableOverride);
            }
        },
        {
            key: "playoutRequestAdapter",
            value: function playoutRequestAdapter(config, sessionItem, vpiSessionRequestOptions) {
                var _this = this;
                return _async_to_generator(function() {
                    var _sessionItem_videoFormatConfig_support, _sessionItem_videoFormatConfig, _sessionItem_display, _this_coreVideoInternal_playerCapabilities, _sessionItem_vac, _CoreVideoInternal_getPropositionExtensions, _this_coreVideoInternal_capabilities_requiresPlayReadyPersistentLicense, _this_coreVideoInternal_capabilities, compatibleStreamPropertyGroup, supportedVideoCodecs, maxVideoFormat, supportedColourSpaces, hdcpEnabled, _tmp, robustness, options;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                compatibleStreamPropertyGroup = _this.coreVideoInternal.getCompatibleStreamPropertyGroupForPlaybackType(sessionItem.type);
                                supportedVideoCodecs = [
                                    OvpVideoCodec.H264
                                ];
                                if ((compatibleStreamPropertyGroup === null || compatibleStreamPropertyGroup === void 0 ? void 0 : compatibleStreamPropertyGroup.maxVideoFormat) === VideoFormat.UHD) {
                                    supportedVideoCodecs = [
                                        OvpVideoCodec.H265,
                                        OvpVideoCodec.H264
                                    ];
                                }
                                maxVideoFormat = _this.getMaxVideoFormat(sessionItem);
                                supportedColourSpaces = _this.adaptSupportedColourSpaces((_sessionItem_videoFormatConfig = sessionItem.videoFormatConfig) === null || _sessionItem_videoFormatConfig === void 0 ? void 0 : (_sessionItem_videoFormatConfig_support = _sessionItem_videoFormatConfig.support) === null || _sessionItem_videoFormatConfig_support === void 0 ? void 0 : _sessionItem_videoFormatConfig_support.supportedColourSpaces, (_sessionItem_display = sessionItem.display) === null || _sessionItem_display === void 0 ? void 0 : _sessionItem_display.playerViewAlwaysPresentedFullScreen);
                                if (!TestingOverrides.shouldDisableHdcpTesting) return [
                                    3,
                                    1
                                ];
                                _tmp = false;
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                return [
                                    4,
                                    _this.getHdcpEnabled(vpiSessionRequestOptions)
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                hdcpEnabled = _tmp;
                                robustness = (_this_coreVideoInternal_playerCapabilities = _this.coreVideoInternal.playerCapabilities()) === null || _this_coreVideoInternal_playerCapabilities === void 0 ? void 0 : _this_coreVideoInternal_playerCapabilities.widevineRobustness;
                                sdkLogger.verbose("OVP Maximum Video Format: ".concat(maxVideoFormat));
                                sdkLogger.verbose("OVP Supported color spaces: ".concat(supportedColourSpaces));
                                sdkLogger.verbose("OVP Supported video codecs: ".concat(supportedVideoCodecs));
                                sdkLogger.verbose("OVP HDCP enabled: ".concat(hdcpEnabled));
                                options = {
                                    parentalControlPin: sessionItem.parentalControlPin,
                                    disableParentalPinCheck: sessionItem.disableParentalPinCheck,
                                    coppaApplies: (_sessionItem_vac = sessionItem.vac) === null || _sessionItem_vac === void 0 ? void 0 : _sessionItem_vac.coppaApplies,
                                    context: sessionItem,
                                    journeyContext: _this.getJourneyContextFromVpiSessionRequestOptions(sessionItem, vpiSessionRequestOptions),
                                    maxVideoFormat: maxVideoFormat,
                                    supportedColourSpaces: supportedColourSpaces,
                                    supportedVideoCodecs: supportedVideoCodecs,
                                    hdcpEnabled: hdcpEnabled
                                };
                                if (((_CoreVideoInternal_getPropositionExtensions = CoreVideoInternal.getPropositionExtensions()) === null || _CoreVideoInternal_getPropositionExtensions === void 0 ? void 0 : _CoreVideoInternal_getPropositionExtensions.robustnessFailover) && robustness) {
                                    options.robustness = robustness;
                                }
                                if (_this.getVariantCapableFromPropositionExtensionsAndSessionItemOverrides(sessionItem)) {
                                    options.variantCapable = true;
                                }
                                if ((_this_coreVideoInternal_capabilities_requiresPlayReadyPersistentLicense = (_this_coreVideoInternal_capabilities = _this.coreVideoInternal.capabilities()).requiresPlayReadyPersistentLicense) === null || _this_coreVideoInternal_capabilities_requiresPlayReadyPersistentLicense === void 0 ? void 0 : _this_coreVideoInternal_capabilities_requiresPlayReadyPersistentLicense.call(_this_coreVideoInternal_capabilities)) {
                                    options.requiresPlayReadyPersistentLicense = true;
                                }
                                if (sessionItem.type === PlaybackType.VOD || sessionItem.type === PlaybackType.Clip || sessionItem.type === PlaybackType.FER || sessionItem.type === PlaybackType.SingleLiveEvent) {
                                    options.providerVariantId = sessionItem.providerVariantId;
                                }
                                if (sessionItem.type === PlaybackType.Live || sessionItem.type === PlaybackType.VOD) {
                                    options.passActivationObject = sessionItem.passActivationObject;
                                }
                                if (vpiSessionRequestOptions.isPrefetch) {
                                    options.isPrefetch = true;
                                }
                                if (vpiSessionRequestOptions.isRetrying) {
                                    options.isRetrying = true;
                                }
                                if (sessionItem.personaParentalControlRating) {
                                    options.personaParentalControlRating = sessionItem.personaParentalControlRating;
                                }
                                return [
                                    2,
                                    options
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "heartbeatRequestOptionsAdapter",
            value: function heartbeatRequestOptionsAdapter(sessionItem) {
                var _sessionItem_vac;
                return {
                    coppaApplies: (_sessionItem_vac = sessionItem.vac) === null || _sessionItem_vac === void 0 ? void 0 : _sessionItem_vac.coppaApplies,
                    context: sessionItem
                };
            }
        },
        {
            key: "thirdPartiesRequestOptionsAdapter",
            value: function thirdPartiesRequestOptionsAdapter(config) {
                var _config_adInsertion, _config_reporting_conviva, _config_reporting, _this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig_watermarking, _this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig, _this_coreVideoInternal_getPropositionExtensions;
                var thirdParties = new Array();
                if ((_config_adInsertion = config.adInsertion) === null || _config_adInsertion === void 0 ? void 0 : _config_adInsertion.enabled) {
                    var _config_adInsertion1, _config_adInsertion2;
                    thirdParties.push('FREEWHEEL');
                    if ((_config_adInsertion1 = config.adInsertion) === null || _config_adInsertion1 === void 0 ? void 0 : _config_adInsertion1.mediaTailor) {
                        thirdParties.push('MEDIATAILOR');
                    }
                    if ((_config_adInsertion2 = config.adInsertion) === null || _config_adInsertion2 === void 0 ? void 0 : _config_adInsertion2.yospace) {
                        thirdParties.push('YOSPACE');
                    }
                }
                if ((_config_reporting = config.reporting) === null || _config_reporting === void 0 ? void 0 : (_config_reporting_conviva = _config_reporting.conviva) === null || _config_reporting_conviva === void 0 ? void 0 : _config_reporting_conviva.enabled) {
                    thirdParties.push('CONVIVA');
                }
                switch((_this_coreVideoInternal_getPropositionExtensions = this.coreVideoInternal.getPropositionExtensions()) === null || _this_coreVideoInternal_getPropositionExtensions === void 0 ? void 0 : (_this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig = _this_coreVideoInternal_getPropositionExtensions.propositionOvpConfig) === null || _this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig === void 0 ? void 0 : (_this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig_watermarking = _this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig.watermarking) === null || _this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig_watermarking === void 0 ? void 0 : _this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig_watermarking.version){
                    case AsidVersion.V3:
                        thirdParties.push('FRIENDS');
                        break;
                    case AsidVersion.V4:
                        thirdParties.push('FRV4');
                        break;
                    default:
                }
                return thirdParties.length > 0 ? thirdParties : null;
            }
        },
        {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Error is always any or unknown when caught
            key: "playoutDataErrorAdapter",
            value: function playoutDataErrorAdapter(e) {
                return OvpErrorAdapter.adapt({
                    error: e,
                    source: OvpErrorSource.PLAYOUT
                });
            }
        },
        {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Error is always any or unknown when caught
            key: "prefetchTokenExchangeErrorAdapter",
            value: function prefetchTokenExchangeErrorAdapter(e) {
                return OvpErrorAdapter.adapt({
                    error: e,
                    source: OvpErrorSource.TOKEN_EXCHANGE
                });
            }
        },
        {
            key: "playerErrorAdapter",
            value: function playerErrorAdapter(e) {
                return OvpErrorAdapter.adapt({
                    error: e,
                    source: OvpErrorSource.PLAYER
                });
            }
        },
        {
            key: "exchangePrefetchTokenRequestOptionsAdapter",
            value: function exchangePrefetchTokenRequestOptionsAdapter(sessionItem, playoutData) {
                var _playoutData_assetMetadata;
                var contentId = ((_playoutData_assetMetadata = playoutData.assetMetadata) === null || _playoutData_assetMetadata === void 0 ? void 0 : _playoutData_assetMetadata.assetId) || sessionItem.key;
                switch(sessionItem.type){
                    case PlaybackType.VOD:
                    case PlaybackType.Clip:
                    case PlaybackType.Preview:
                    case PlaybackType.FER:
                        return {
                            contentId: contentId,
                            providerVariantId: sessionItem.providerVariantId
                        };
                    case PlaybackType.Live:
                        return {
                            serviceKey: contentId
                        };
                    case PlaybackType.SingleLiveEvent:
                        return {
                            eventId: contentId,
                            providerVariantId: sessionItem.providerVariantId
                        };
                    default:
                        throw this.playoutDataErrorAdapter('Unknown session item type');
                }
            }
        },
        {
            // TODO ☢️WID-1687a: https://github.com/sky-uk/core-video-team/issues/4031
            key: "applyEndpointModifications",
            value: function applyEndpointModifications(originalCdn, sessionItem, transport, drmType) {
                var _this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig, _this_coreVideoInternal_getPropositionExtensions;
                var modifiedCdn = {
                    url: originalCdn.url,
                    name: originalCdn.cdn,
                    streamInfo: getLinearStreamInfo(originalCdn.url)
                };
                if (sessionItem.shouldUseTwoSecondFragments) {
                    var isNormalVod = modifiedCdn.url.includes(NORMAL_VOD_SIX_SECONDS);
                    if (isNormalVod) {
                        modifiedCdn.url = modifiedCdn.url.replace(NORMAL_VOD_SIX_SECONDS, NORMAL_VOD_TWO_SECONDS);
                    } else {
                        modifiedCdn.url = modifiedCdn.url.replace(SHORTFORM_SIX_SECONDS, SHORTFORM_TWO_SECONDS);
                    }
                }
                // TODO: Needed until OVP return PS4 specific streams. No ETA :(
                var fxbwReplacement = (_this_coreVideoInternal_getPropositionExtensions = this.coreVideoInternal.getPropositionExtensions()) === null || _this_coreVideoInternal_getPropositionExtensions === void 0 ? void 0 : (_this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig = _this_coreVideoInternal_getPropositionExtensions.propositionOvpConfig) === null || _this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig === void 0 ? void 0 : _this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig.fxbwReplacement;
                if ((fxbwReplacement === null || fxbwReplacement === void 0 ? void 0 : fxbwReplacement[this.coreVideoInternal.deviceType()]) && [
                    PlaybackType.VOD,
                    PlaybackType.Preview,
                    PlaybackType.Clip
                ].includes(sessionItem.type)) {
                    modifiedCdn.url = modifiedCdn.url.replace(STANDARD_MPD, PS4_MPD);
                }
                if (originalCdn.url !== modifiedCdn.url) {
                    sdkLogger.info("OVP stream endpoint modified:\n  from ".concat(originalCdn.url, '\n    to "').concat(modifiedCdn.url, '"'));
                }
                return modifiedCdn;
            }
        },
        {
            key: "buildPlayoutCdnList",
            value: function buildPlayoutCdnList(ovpData, sessionItem, dvrWindowSupported) {
                var _this = this;
                var _this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig, _this_coreVideoInternal_getPropositionExtensions;
                var ovpEndpoints = ovpData.endpoints, _ovpData_format = ovpData.format, transport = _ovpData_format.transport, _$DrmType = _ovpData_format.protection, audioTracks = ovpData.audioTracks, subtitleTracks = ovpData.subtitleTracks, streamVariants = ovpData.streamVariants;
                var type = sessionItem.type, preferredWindowDuration = sessionItem.preferredWindowDuration, preferredAudioLanguages = sessionItem.preferredAudioLanguages, preferredSubtitlesLanguages = sessionItem.preferredSubtitlesLanguages, preferredAudioMetadata = sessionItem.preferredAudioMetadata, preferredSubtitleMetadata = sessionItem.preferredSubtitleMetadata;
                var _this_coreVideoInternal_playerCapabilities = this.coreVideoInternal.playerCapabilities(), maxAudioTracks = _this_coreVideoInternal_playerCapabilities.maxAudioTracks, maxSubtitleTracks = _this_coreVideoInternal_playerCapabilities.maxSubtitleTracks, hasForcedNarrativeSupport = _this_coreVideoInternal_playerCapabilities.hasForcedNarrativeSupport, supportedAudioCodecs = _this_coreVideoInternal_playerCapabilities.supportedAudioCodecs;
                var isLiveStream = checkIsManifestLinearType(type);
                var cdnParameters = (_this_coreVideoInternal_getPropositionExtensions = this.coreVideoInternal.getPropositionExtensions()) === null || _this_coreVideoInternal_getPropositionExtensions === void 0 ? void 0 : (_this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig = _this_coreVideoInternal_getPropositionExtensions.propositionOvpConfig) === null || _this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig === void 0 ? void 0 : _this_coreVideoInternal_getPropositionExtensions_propositionOvpConfig.cdnParameters;
                var checkLimit = function() {
                    var tracks = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], preferredLangs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], tracksLimit = arguments.length > 2 ? arguments[2] : void 0, preferredMetadata = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
                    if (!tracksLimit || tracksLimit === Infinity) {
                        return 'all';
                    }
                    if (preferredMetadata.length > 0) {
                        var trackLocales = tracks.map(function(track) {
                            return track.locale.split('-')[0];
                        });
                        var preferredMetadataLanguages = preferredMetadata.map(function(pm) {
                            return pm.languageTag.split('-')[0];
                        });
                        var notPreferred = trackLocales.filter(function(track) {
                            return preferredMetadataLanguages.indexOf(track) === -1;
                        });
                        return preferredMetadataLanguages.concat(notPreferred).slice(0, tracksLimit).join(',');
                    } else {
                        var trackLocales1 = tracks.map(function(track) {
                            return track.locale.split('-')[0];
                        });
                        var notPreferred1 = trackLocales1.filter(function(track) {
                            return preferredLangs.indexOf(track) === -1;
                        });
                        return preferredLangs.concat(notPreferred1).slice(0, tracksLimit).join(',');
                    }
                };
                var updateCdnUrl = function(cdn) {
                    var url = Url.parse(cdn.url).setUrlScheme(_this.shouldUseHttpsScheme(sessionItem, transport, _$DrmType));
                    url.if(cdnParameters === null || cdnParameters === void 0 ? void 0 : cdnParameters.audio, function(u) {
                        return u.setParameter('audio', checkLimit(audioTracks, preferredAudioLanguages, maxAudioTracks, preferredAudioMetadata));
                    }).if(cdnParameters === null || cdnParameters === void 0 ? void 0 : cdnParameters.subtitle, function(u) {
                        return u.setParameter('subtitle', checkLimit(subtitleTracks, preferredSubtitlesLanguages, maxSubtitleTracks, preferredSubtitleMetadata));
                    }).if(cdnParameters === null || cdnParameters === void 0 ? void 0 : cdnParameters.forcedNarrative, function(u) {
                        return u.setParameter('forcedNarrative', (hasForcedNarrativeSupport !== null && hasForcedNarrativeSupport !== void 0 ? hasForcedNarrativeSupport : true).toString());
                    }).if(cdnParameters === null || cdnParameters === void 0 ? void 0 : cdnParameters.trickplay, function(u) {
                        var _this_coreVideoInternal_capabilities_hasThumbnailScrubbingSupport;
                        return u.setParameter('trickplay', ((_this_coreVideoInternal_capabilities_hasThumbnailScrubbingSupport = _this.coreVideoInternal.capabilities().hasThumbnailScrubbingSupport()) !== null && _this_coreVideoInternal_capabilities_hasThumbnailScrubbingSupport !== void 0 ? _this_coreVideoInternal_capabilities_hasThumbnailScrubbingSupport : true).toString());
                    }).if((cdnParameters === null || cdnParameters === void 0 ? void 0 : cdnParameters.audioCodec) && !isLiveStream, function(u) {
                        return u.setParameter('audioCodec', _this.coreVideoInternal.getAllowedAudioCodecs(supportedAudioCodecs, type));
                    });
                    return _object_spread_props(_object_spread({}, cdn), {
                        url: url.toString()
                    });
                };
                var getCdnsFromOvp = function() {
                    if (isLiveStream) {
                        var _CoreVideoInternal_getPropositionExtensions_propositionOvpConfig_endpoints_sessionItem_type, _CoreVideoInternal_getPropositionExtensions_propositionOvpConfig_endpoints, _CoreVideoInternal_getPropositionExtensions_propositionOvpConfig, _CoreVideoInternal_getPropositionExtensions, _CoreVideoInternal_getPropositionExtensions_propositionOvpConfig_cdnParameters_isSinglePeriod_CoreVideoInternal_deviceType, _CoreVideoInternal_getPropositionExtensions_propositionOvpConfig_cdnParameters_isSinglePeriod, _CoreVideoInternal_getPropositionExtensions_propositionOvpConfig_cdnParameters, _CoreVideoInternal_getPropositionExtensions_propositionOvpConfig1, _CoreVideoInternal_getPropositionExtensions1;
                        var playoutCdns = ovpEndpoints.map(function(endpoint) {
                            return {
                                url: endpoint.url,
                                name: endpoint.cdn
                            };
                        });
                        if (streamVariants) {
                            playoutCdns = OvpUrlTemplateManager.parseUrlTemplate({
                                ovpEndpoints: playoutCdns,
                                streamVariants: streamVariants,
                                dvrWindowSupported: dvrWindowSupported,
                                playbackType: type,
                                preferredWindowDuration: preferredWindowDuration
                            });
                        } else if ((_CoreVideoInternal_getPropositionExtensions = CoreVideoInternal.getPropositionExtensions()) === null || _CoreVideoInternal_getPropositionExtensions === void 0 ? void 0 : (_CoreVideoInternal_getPropositionExtensions_propositionOvpConfig = _CoreVideoInternal_getPropositionExtensions.propositionOvpConfig) === null || _CoreVideoInternal_getPropositionExtensions_propositionOvpConfig === void 0 ? void 0 : (_CoreVideoInternal_getPropositionExtensions_propositionOvpConfig_endpoints = _CoreVideoInternal_getPropositionExtensions_propositionOvpConfig.endpoints) === null || _CoreVideoInternal_getPropositionExtensions_propositionOvpConfig_endpoints === void 0 ? void 0 : (_CoreVideoInternal_getPropositionExtensions_propositionOvpConfig_endpoints_sessionItem_type = _CoreVideoInternal_getPropositionExtensions_propositionOvpConfig_endpoints[sessionItem.type]) === null || _CoreVideoInternal_getPropositionExtensions_propositionOvpConfig_endpoints_sessionItem_type === void 0 ? void 0 : _CoreVideoInternal_getPropositionExtensions_propositionOvpConfig_endpoints_sessionItem_type.shouldApplyLinearEndpointModifications) {
                            playoutCdns = OvpUrlExtendedWindowManager.buildExtendedAndFullEventDvrWindowWhenPossible(playoutCdns, type, preferredWindowDuration);
                        }
                        /* Begin dirty hack to support single period for linear streams on 2016 Samsung */ var isLinearStream = sessionItem.type === PlaybackType.Live;
                        var isSinglePeriod = (_CoreVideoInternal_getPropositionExtensions1 = CoreVideoInternal.getPropositionExtensions()) === null || _CoreVideoInternal_getPropositionExtensions1 === void 0 ? void 0 : (_CoreVideoInternal_getPropositionExtensions_propositionOvpConfig1 = _CoreVideoInternal_getPropositionExtensions1.propositionOvpConfig) === null || _CoreVideoInternal_getPropositionExtensions_propositionOvpConfig1 === void 0 ? void 0 : (_CoreVideoInternal_getPropositionExtensions_propositionOvpConfig_cdnParameters = _CoreVideoInternal_getPropositionExtensions_propositionOvpConfig1.cdnParameters) === null || _CoreVideoInternal_getPropositionExtensions_propositionOvpConfig_cdnParameters === void 0 ? void 0 : (_CoreVideoInternal_getPropositionExtensions_propositionOvpConfig_cdnParameters_isSinglePeriod = _CoreVideoInternal_getPropositionExtensions_propositionOvpConfig_cdnParameters.isSinglePeriod) === null || _CoreVideoInternal_getPropositionExtensions_propositionOvpConfig_cdnParameters_isSinglePeriod === void 0 ? void 0 : (_CoreVideoInternal_getPropositionExtensions_propositionOvpConfig_cdnParameters_isSinglePeriod_CoreVideoInternal_deviceType = _CoreVideoInternal_getPropositionExtensions_propositionOvpConfig_cdnParameters_isSinglePeriod[CoreVideoInternal.deviceType]) === null || _CoreVideoInternal_getPropositionExtensions_propositionOvpConfig_cdnParameters_isSinglePeriod_CoreVideoInternal_deviceType === void 0 ? void 0 : _CoreVideoInternal_getPropositionExtensions_propositionOvpConfig_cdnParameters_isSinglePeriod_CoreVideoInternal_deviceType.call(_CoreVideoInternal_getPropositionExtensions_propositionOvpConfig_cdnParameters_isSinglePeriod);
                        if (isSinglePeriod && isLinearStream) {
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = playoutCdns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var cdn = _step.value;
                                    cdn.url = cdn.url.replace('CMAF_CTR_H1', 'CMAF_CTR_H1_SP').replace('CMAF_CTR_S1', 'CMAF_CTR_S1_SP');
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        /* End dirty hack to support single period for linear streams on 2016 Samsung */ return playoutCdns.map(function(cdn) {
                            return _object_spread_props(_object_spread({}, cdn), {
                                streamInfo: getLinearStreamInfo(cdn.url)
                            });
                        }).map(updateCdnUrl);
                    }
                    return ovpEndpoints.map(function(endpoint) {
                        return _this.applyEndpointModifications(endpoint, sessionItem, transport, _$DrmType);
                    }).map(updateCdnUrl);
                };
                return getCdnsFromOvp();
            }
        },
        {
            key: "shouldUseHttpsScheme",
            value: function shouldUseHttpsScheme(sessionItem, transport, drmType) {
                if (sessionItem.disableCdnOverwrite) {
                    return false;
                }
                if (this.coreVideoInternal.capabilities().prefersHttp()) {
                    return false;
                }
                return true;
            }
        },
        {
            key: "penalizeSpecificCdn",
            value: function penalizeSpecificCdn(ovpData, penalizedCdnName) {
                if (!penalizedCdnName) {
                    return ovpData;
                }
                var penalizedCdnIndex = ovpData.endpoints.findIndex(function(endpoint) {
                    return endpoint.cdn === penalizedCdnName;
                });
                if (penalizedCdnIndex === -1) {
                    return ovpData;
                }
                var adaptedEndpoints = _to_consumable_array(ovpData.endpoints);
                var _adaptedEndpoints_splice = _sliced_to_array(adaptedEndpoints.splice(penalizedCdnIndex, 1), 1), penalizedEndpoint = _adaptedEndpoints_splice[0];
                adaptedEndpoints.push(penalizedEndpoint);
                sdkLogger.info("Penalizing ".concat(penalizedCdnName, " cdn from ovp playout response. Endpoint: ").concat(penalizedEndpoint.url));
                return _object_spread_props(_object_spread({}, ovpData), {
                    endpoints: adaptedEndpoints
                });
            }
        },
        {
            key: "playoutResponseAdapter",
            value: function playoutResponseAdapter(param, sessionItem, vpiSessionResponseOptions) {
                var ovpData = param.ovpData;
                var _ovpData_adInstructions, _ovpData_adInstructions1;
                var adaptedOvpAsset = this.penalizeSpecificCdn(ovpData.asset, vpiSessionResponseOptions.penalizedCdnName);
                var adaptedData = _object_spread_props(_object_spread({
                    // Depend on the application
                    autoplay: sessionItem.autoplay,
                    muted: sessionItem.muted,
                    preferredAudioMetadata: sessionItem.preferredAudioMetadata,
                    preferredAudioLanguages: sessionItem.preferredAudioLanguages,
                    preferredSubtitleMetadata: sessionItem.preferredSubtitleMetadata,
                    preferredSubtitlesLanguages: sessionItem.preferredSubtitlesLanguages,
                    playerBitrateLimits: sessionItem.playerBitrateLimits,
                    type: sessionItem.type,
                    // Depend on OVP
                    cdns: this.buildPlayoutCdnList(adaptedOvpAsset, sessionItem, ovpData.dvrWindowSupported),
                    stream: this.getStream(adaptedOvpAsset.format, ovpData.videoFormat),
                    durationMs: 'durationMs' in ovpData ? ovpData.durationMs : 0,
                    containsMandatoryPinEvents: 'containsMandatoryPinEvents' in ovpData ? Boolean(ovpData.containsMandatoryPinEvents) : false
                }, this.getAddonData(ovpData, sessionItem), // Depend on both the application and OVP
                this.getDrmData(ovpData)), {
                    abrConfiguration: _object_spread({}, sessionItem.abrConfiguration),
                    position: this.getPosition(sessionItem, ovpData.bookmark),
                    vamMidrollEnabled: true,
                    vamPrerollEnabled: false,
                    display: sessionItem.display,
                    // From SDK itself
                    sessionId: sessionItem.sessionId
                });
                var playoutRules = this.getPlayoutRules(ovpData);
                if (Object.keys(playoutRules).length) {
                    adaptedData.playoutRules = playoutRules;
                }
                // Must be explicitly false
                if (((_ovpData_adInstructions = ovpData.adInstructions) === null || _ovpData_adInstructions === void 0 ? void 0 : _ovpData_adInstructions.dai_MidRollEnabled) === 'false') {
                    adaptedData.vamMidrollEnabled = false;
                }
                // Must be explicitly true
                if (!vpiSessionResponseOptions.isRetrying && ((_ovpData_adInstructions1 = ovpData.adInstructions) === null || _ovpData_adInstructions1 === void 0 ? void 0 : _ovpData_adInstructions1.dai_PreRollEnabled) === 'true') {
                    adaptedData.vamPrerollEnabled = true;
                }
                return _object_spread_props(_object_spread({}, adaptedData), {
                    custom: _object_spread({}, this.getCustomData(sessionItem, ovpData), adaptedData.custom)
                });
            }
        },
        {
            key: "getPlayoutRules",
            value: function getPlayoutRules(ovpData) {
                var playoutRules = {};
                if (ovpData.dvrWindowSupported !== undefined) {
                    playoutRules.dvrWindowSupported = ovpData.dvrWindowSupported;
                }
                return playoutRules;
            }
        },
        {
            key: "getStream",
            value: function getStream(format, videoFormat) {
                var acodec = format.acodec, vcodec = format.vcodec, container = format.container, protection = format.protection, transport = format.transport, colourSpace = format.colourSpace;
                return {
                    audioCodec: acodec,
                    videoCodec: vcodec,
                    colourSpace: this.mapOvpColourFormatToSdkFormat(colourSpace),
                    container: container,
                    protection: this.mapDrmTypeToSdkDrmType(protection),
                    protocol: this.getStreamingProtocol(transport),
                    quality: this.getStreamQuality(videoFormat),
                    frameRate: format.frameRate
                };
            }
        },
        {
            key: "mapOvpColourFormatToSdkFormat",
            value: function mapOvpColourFormatToSdkFormat(desiredOvpColourSpace) {
                if (desiredOvpColourSpace) {
                    var entry = VideoColourSpace.SDR;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        // Iterate for case insensitive comparison
                        for(var _iterator = SDK_COLOUR_SPACE_TO_OVP[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = _sliced_to_array(_step.value, 2), sdkColourSpace = _step_value[0], ovpColourSpace = _step_value[1];
                            if (desiredOvpColourSpace.toUpperCase() === ovpColourSpace.toUpperCase()) {
                                entry = sdkColourSpace;
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return entry;
                }
            }
        },
        {
            key: "mapDrmTypeToSdkDrmType",
            value: function mapDrmTypeToSdkDrmType(DrmType) {
                return OVP_DRM_TYPE_TO_SDK_DRM_TYPE[DrmType];
            }
        },
        {
            key: "getStreamingProtocol",
            value: function getStreamingProtocol(transport) {
                return STREAM_TRANSPORT_TO_STREAMING_PROTOCOL_MAP[transport];
            }
        },
        {
            key: "getStreamQuality",
            value: function getStreamQuality(videoFormat) {
                return VIDEO_FORMAT_TO_STREAM_QUALITY_MAP[videoFormat];
            }
        },
        {
            key: "getCustomData",
            value: function getCustomData(sessionItem, ovpData) {
                var _sessionItem_user_ids_conviva, _sessionItem_user_ids, _sessionItem_user;
                if (this.coreVideoInternal.deviceType() === DeviceType.YouView) {
                    var assetId = this.getAssetId(ovpData);
                    return {
                        assetId: assetId,
                        nativeReporting: _object_spread({}, sessionItem.reporting)
                    };
                }
                return {
                    nativeReporting: _object_spread_props(_object_spread({}, sessionItem.reporting), {
                        userId: (_sessionItem_user = sessionItem.user) === null || _sessionItem_user === void 0 ? void 0 : (_sessionItem_user_ids = _sessionItem_user.ids) === null || _sessionItem_user_ids === void 0 ? void 0 : (_sessionItem_user_ids_conviva = _sessionItem_user_ids.conviva) === null || _sessionItem_user_ids_conviva === void 0 ? void 0 : _sessionItem_user_ids_conviva.profileid
                    })
                };
            }
        },
        {
            key: "getDrmData",
            value: function getDrmData(ovpData) {
                if (!ovpData.protection) {
                    return {};
                } else if (ovpData.protection.type === DrmType.PlayReady) {
                    var _ovpData_protection = ovpData.protection, licenceAcquisitionUrl = _ovpData_protection.licenceAcquisitionUrl, deviceId = _ovpData_protection.deviceId, headers = _ovpData_protection.headers;
                    return {
                        drmConfiguration: {
                            type: SdkDrmType.PlayReady,
                            licenceAcquisitionUrl: licenceAcquisitionUrl,
                            customChallengeData: "01".concat(deviceId),
                            deviceId: deviceId,
                            headers: headers
                        }
                    };
                } else if (ovpData.protection.type === DrmType.Marlin) {
                    var _ovpData_protection1 = ovpData.protection, licenceToken = _ovpData_protection1.licenceToken, licenceAcquisitionUrl1 = _ovpData_protection1.licenceAcquisitionUrl;
                    return {
                        drmConfiguration: {
                            type: SdkDrmType.Marlin,
                            licenceAcquisitionUrl: licenceAcquisitionUrl1
                        },
                        custom: {
                            licenceToken: licenceToken
                        }
                    };
                } else if (ovpData.protection.type === DrmType.Widevine) {
                    var _ovpData_protection2 = ovpData.protection, licenceAcquisitionUrl2 = _ovpData_protection2.licenceAcquisitionUrl, headers1 = _ovpData_protection2.headers;
                    return {
                        drmConfiguration: {
                            type: SdkDrmType.Widevine,
                            licenceAcquisitionUrl: licenceAcquisitionUrl2,
                            headers: headers1
                        }
                    };
                } else if (ovpData.protection.type === DrmType.Fairplay) {
                    var _CoreVideoInternal_getPropositionExtensions_propositionOvpConfig_drm, _CoreVideoInternal_getPropositionExtensions_propositionOvpConfig, _CoreVideoInternal_getPropositionExtensions;
                    var protectionData = ovpData.protection;
                    if ((_CoreVideoInternal_getPropositionExtensions = CoreVideoInternal.getPropositionExtensions()) === null || _CoreVideoInternal_getPropositionExtensions === void 0 ? void 0 : (_CoreVideoInternal_getPropositionExtensions_propositionOvpConfig = _CoreVideoInternal_getPropositionExtensions.propositionOvpConfig) === null || _CoreVideoInternal_getPropositionExtensions_propositionOvpConfig === void 0 ? void 0 : (_CoreVideoInternal_getPropositionExtensions_propositionOvpConfig_drm = _CoreVideoInternal_getPropositionExtensions_propositionOvpConfig.drm) === null || _CoreVideoInternal_getPropositionExtensions_propositionOvpConfig_drm === void 0 ? void 0 : _CoreVideoInternal_getPropositionExtensions_propositionOvpConfig_drm.excludeCertificateUrl) {
                        return {
                            drmConfiguration: _object_spread_props(_object_spread({}, protectionData), {
                                type: SdkDrmType.Fairplay
                            })
                        };
                    }
                    // TODO: Remove this once certificate URL is added to OVP API
                    var relativePath = 'drm/certificate/fairplay.cer';
                    var licenceAcquisitionUrlObj = new URL(protectionData.licenceAcquisitionUrl);
                    var staticCertificateUrl = "".concat(licenceAcquisitionUrlObj.origin, "/").concat(relativePath);
                    return {
                        drmConfiguration: _object_spread_props(_object_spread({}, protectionData), {
                            type: SdkDrmType.Fairplay,
                            certificateUrl: staticCertificateUrl
                        })
                    };
                }
            }
        },
        {
            // condition for checking if a killswitch should be enabled to disable ads
            key: "isKillswitchEnabled",
            value: function isKillswitchEnabled(sessionItem, freewheel) {
                var adCompatibilityLegacyLinearSupport = freewheel.adCompatibilityLegacyLinearSupport, adCompatibilityLegacyVodSupport = freewheel.adCompatibilityLegacyVodSupport;
                var isVodType = checkIsManifestVodType(sessionItem.type);
                var isLinearType = checkIsManifestLinearType(sessionItem.type);
                return isLinearType && adCompatibilityLegacyLinearSupport || isVodType && adCompatibilityLegacyVodSupport;
            }
        },
        {
            key: "getFreewheelAdvertisingData",
            value: function getFreewheelAdvertisingData(sessionItem, freewheel) {
                var adCompatibilityEncodingProfile = freewheel.adCompatibilityEncodingProfile, contentId = freewheel.contentId;
                var isKillswitchEnabled = this.isKillswitchEnabled(sessionItem, freewheel);
                if (isKillswitchEnabled) {
                    sdkLogger.warn('OVP Freewheel Ads Killswitch is enabled, requests for adverts will not be sent');
                }
                return {
                    adCompatibilityEncodingProfile: adCompatibilityEncodingProfile,
                    contentId: contentId,
                    isKillswitchEnabled: isKillswitchEnabled
                };
            }
        },
        {
            key: "getYospaceAdvertisingData",
            value: function getYospaceAdvertisingData(sessionItem, yospace) {
                var eventId = yospace.eventId, streamId = yospace.streamId;
                return {
                    eventId: eventId,
                    streamId: streamId
                };
            }
        },
        {
            key: "getAdvertisingData",
            value: function getAdvertisingData(ovpData, sessionItem) {
                var advertising;
                if (_type_of(ovpData.thirdParties) === 'object') {
                    var freewheel = ovpData.thirdParties.FREEWHEEL;
                    var yospace = ovpData.thirdParties.YOSPACE;
                    advertising = {};
                    if (freewheel) {
                        Object.assign(advertising, this.getFreewheelAdvertisingData(sessionItem, freewheel));
                    }
                    if (yospace) {
                        Object.assign(advertising, this.getYospaceAdvertisingData(sessionItem, yospace));
                    }
                }
                return advertising;
            }
        },
        {
            key: "getAddonData",
            value: function getAddonData(ovpData, sessionItem) {
                var _ovpData_session, _ovpData_session1;
                var assetId = this.getAssetId(ovpData);
                var addonData = {
                    assetMetadata: {
                        assetId: assetId
                    }
                };
                if (ovpData.thirdParties && ovpData.thirdParties.FRV4) {
                    var _ovpData_thirdParties_FRV4 = ovpData.thirdParties.FRV4, token = _ovpData_thirdParties_FRV4.token, userId = _ovpData_thirdParties_FRV4.userId;
                    addonData.watermarking = {
                        token: token,
                        userId: userId
                    };
                }
                if (ovpData.thirdParties && ovpData.thirdParties.FRIENDS && !ovpData.thirdParties.FRV4) {
                    var _ovpData_thirdParties_FRIENDS = ovpData.thirdParties.FRIENDS, accessToken = _ovpData_thirdParties_FRIENDS.token, userId1 = _ovpData_thirdParties_FRIENDS.userId, sourceName = _ovpData_thirdParties_FRIENDS.sourceName;
                    addonData.watermarking = {
                        accessToken: accessToken,
                        userId: userId1,
                        sourceName: sourceName
                    };
                }
                if (ovpData.events && ovpData.events.heartbeat) {
                    var _ovpData_events_heartbeat = ovpData.events.heartbeat, url = _ovpData_events_heartbeat.url, frequency = _ovpData_events_heartbeat.frequency, allowedMissed = _ovpData_events_heartbeat.allowedMissed;
                    addonData.heartbeat = {
                        allowedMissed: allowedMissed,
                        frequencyMs: frequency,
                        url: url
                    };
                }
                if ((ovpData === null || ovpData === void 0 ? void 0 : (_ovpData_session = ovpData.session) === null || _ovpData_session === void 0 ? void 0 : _ovpData_session.prePlayoutId) && (ovpData === null || ovpData === void 0 ? void 0 : (_ovpData_session1 = ovpData.session) === null || _ovpData_session1 === void 0 ? void 0 : _ovpData_session1.metadataToken)) {
                    addonData.prefetch = {
                        prePlayoutId: ovpData.session.prePlayoutId,
                        metadataToken: ovpData.session.metadataToken
                    };
                }
                if (ovpData === null || ovpData === void 0 ? void 0 : ovpData.schedule) {
                    addonData.programSchedule = ovpData.schedule;
                }
                if ('nielsenTrackingType' in ovpData && ovpData.nielsenTrackingType) {
                    var _obj;
                    var nielsenTrackingTypeMap = (_obj = {}, _define_property(_obj, OvpNielsenTrackingType.DCR, NielsenTrackingType.DCR), _define_property(_obj, OvpNielsenTrackingType.DTVR, NielsenTrackingType.DTVR), _define_property(_obj, OvpNielsenTrackingType.not_required, NielsenTrackingType.NOT_REQUIRED), _obj);
                    addonData.nielsen = {
                        nielsenTrackingType: nielsenTrackingTypeMap[ovpData.nielsenTrackingType]
                    };
                }
                var advertising = this.getAdvertisingData(ovpData, sessionItem);
                if (advertising) {
                    addonData.advertising = advertising;
                }
                return addonData;
            }
        },
        {
            key: "getPosition",
            value: function getPosition(sessionItem) {
                var ovpBookmark = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (typeof sessionItem.startPosition === 'number') {
                    return sessionItem.startPosition;
                } else if ('position' in ovpBookmark) {
                    return Number(ovpBookmark.position);
                }
            }
        },
        {
            key: "getAssetId",
            value: function getAssetId(ovpData) {
                if ('serviceKey' in ovpData) {
                    return ovpData.serviceKey;
                } else {
                    return ovpData.contentId;
                }
            }
        }
    ]);
    return OvpDataAdapters;
}();

//# sourceMappingURL=ovp-data-adapters.js.map